// 英文

export default {
  t1: 'Complete',
  t5: 'Pay Now',
  t6: 'Bind and authorize',
}
